import { useState } from 'react'
import styles from './index.module.less';
import Header from './components/header'
import Home from './components/home'
import ProductInfo from './components/productInfo'
import About from './components/about'
import Footer from './components/footer'

export default function Main () {
  const [tag, setTag] = useState<number>(0)
  return (<div className={styles.main}>
    <Header tag={tag} setTag={setTag} />
    {tag === 0 ? <Home /> : null}
    {tag === 1 ? <ProductInfo /> : null}
    {tag === 2 ? <About /> : null}
    <Footer />
  </div>)
}